import { useEffect, useState } from 'react';
import { useAuth, parseToken } from '@cko/dashboard-shared';

interface InlineHookStatus {
  isLoading: boolean;
  errorCode?: string;
}

export const useAuthInlineHookStatus = () => {
  const { authService } = useAuth();
  const [inlineHookStatus, setInlineHookStatus] = useState<InlineHookStatus>({ isLoading: true });

  const getTokenPayload = async () => {
    const response = await authService.getAccessToken();

    if (response === undefined) {
      // eslint-disable-next-line no-console
      console.warn("Access token can't be retrieved.");

      return;
    }

    const tokenPayload = parseToken(response);
    setInlineHookStatus({
      isLoading: false,
      errorCode: tokenPayload.cko_inline_hook_error,
    });
  };

  useEffect(() => {
    getTokenPayload();
  }, []);

  return inlineHookStatus;
};
